import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import KadaiGosh from "../../../img/Icon/KadaiGosh.svg";
import Chicken from "../../../img/Chicken.png";
import Rice from "../../../img/Icon/Rice.svg";
import FriedChicken from "../../../img/Icon/FriedChicken.svg";
import Drinks from "../../../img/Icon/Drinks.svg";
import ButterRoti from "../../../img/Icon/ButterRoti.png";
import Kheericon from "../../../img/Icon/Kheer_icon.png";
import soup from "../../../img/Icon/soup.svg";
import user_icon from "../../../img/Icon/user_icon.svg";
import starticon from "../../../img/Icon/starticon.png";
import calender from "../../../img/Icon/calender.svg";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Header from "../Header/Header";
import Select from "react-select";
import Sidebarmenu from "../../Sidebar/Sidebarmenu";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useDispatch } from "react-redux";
import { feed_back, getCatererList, getFeedbackdata } from "../../../Redux/Reducer/AuthReducer";
import { api_url } from "../../../Redux/Reducer/AuthReducer";
import ReactPaginate from 'react-paginate';
import loadergif from '../../../img/landing/loader123.gif';
import ven from "../../../img/ven.png";
import { CSVLink } from 'react-csv';
import Modal from "react-modal";
import ScheduleFeedbackContent from "./ScheduleFeedbackContent";
import { getHijriParts } from "../../HijriCalendar/getHijriDate";
import MiqaatBadge from "../../HijriCalendar/MiqaatBadge";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

// Module-level (not per-render) since neither depends on component state -
// also needed by FeedbackRow and the day-rating chart's grouping below.
function convertDateForIos(date) {
  const arr = date.split(/[- :]/);
  return new Date(arr[2], arr[0] - 1, arr[1]);
}

// Taste/Quantity/Dish collapsed into one overall Rating (their average) -
// a 0/blank component rating means that aspect wasn't rated, not "rated 0",
// so it's excluded from the average rather than dragging it down.
function getOverallRating(item) {
  const ratings = [item.taste_rating, item.quantity_rating, item.dish_rating]
    .map((r) => Number(r))
    .filter((r) => !Number.isNaN(r) && r > 0);
  if (ratings.length === 0) return null;
  return ratings.reduce((sum, r) => sum + r, 0) / ratings.length;
}

// "YYYY-MM-DD" grouping key for the day-rating chart - built from the same
// convertDateForIos parsing already proven correct for schedule_day on this
// page, not a fresh guess at the field's format.
function getDayKey(item) {
  const d = convertDateForIos(item.schedule_day);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// One row of the main feedback list table.
function FeedbackRow({ item, userRole, onOpenFeedback }) {
  const date = convertDateForIos(item.schedule_day);
  const day = date.toLocaleString("en-US", { weekday: "long" });
  const month = date.toLocaleString("en-US", { month: "long" });
  const numericDate = date.getDate();
  const twoDigitYear = date.getFullYear();
  const overallRating = getOverallRating(item);

  return (
    <tr key={item.id}>
      <th scope="row">
        <div className="Calendar_card">
          {" "}
          <h6>{day}</h6>
          <h1>{numericDate}</h1>
          <p>
            {month}, {twoDigitYear}
          </p>
          <p className="hijri_date">
            <span className="hijri_day">{getHijriParts(date).day}</span>
            <span className="hijri_month">{getHijriParts(date).month}</span>
            <MiqaatBadge date={date} />
          </p>
        </div>
      </th>
      <th scope="row">
        <ul className="thali_menu_list">
          {item.save_draft == "1" && (
            <span className="Draft_thali_event">{item.save_draft == "1" ? "Draft" : ""}</span>
          )}
          {item.schedule_type == "MIQAAT" && item.is_niyaaz != "1" && (
            <span className="Draft_MIQAAT_event">{item.schedule_type == "MIQAAT" ? "MIQAAT" : ""}</span>
          )}
          {item.schedule_type == "MIQAAT" && item.is_niyaaz == "1" && (
            <span className="Draft_NIYAAZ_event">
              {item.schedule_type == "MIQAAT" && item.is_niyaaz == "1" ? "PRIVATE" : ""}
            </span>
          )}
          {item.schedule_type == "FMBTHALI" && item.is_niyaaz == "1" && (
            <span className="Draft_NIYAAZ_event">
              {item.schedule_type == "FMBTHALI" && item.is_niyaaz == "1" ? "MIQAAT-THALI" : ""}
            </span>
          )}
          {item.menu && JSON.parse(item.menu).map((menu, index) => <li key={index}>{menu ? menu : "-"}</li>)}
        </ul>
      </th>
      <th scope="row">
        {item.jamanType == "COOKING" && (
          <ul className="thali_menu_list">
            {item.cater_name1 === item.cater_name1 && (
              <li>
                <img src={user_icon} className="img-fluid" alt="" />
                &nbsp; &nbsp;{item.cater_name1 ? item.cater_name1 : "NA"}
              </li>
            )}
            {item.cater_name2 !== null && (
              <li>
                <img src={user_icon} className="img-fluid" alt="" />
                &nbsp; &nbsp;{item.cater_name2 ? item.cater_name2 : "NA"}
              </li>
            )}
          </ul>
        )}
        {item.jamanType == "ORDERING" && (
          <ul className="thali_menu_list">
            <li>
              {item.jamanType == "ORDERING" && (
                <span className="Draft_ordering_event">{item.jamanType == "ORDERING" ? "ORDERING" : ""}</span>
              )}
            </li>
            <li>
              <img src={ven} className="img-fluid" width="16px" height="16px" alt="" />
              &nbsp; &nbsp;
              {item.order_by ? item.order_by : "-"}
            </li>
          </ul>
        )}
      </th>
      <th scope="row">
        <ul className="thali_menu_list">
          <li style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <img src={starticon} className="img-fluid" alt="" />
              &nbsp;&nbsp;&nbsp;{overallRating != null ? overallRating.toFixed(1) : "-"} &nbsp;&nbsp; &nbsp;
            </div>
            {userRole.includes("ADM") ? (
              <Link>
                <button onClick={() => onOpenFeedback(item)} className="Count_btn">
                  {" "}
                  {item.feedback_count ? item.feedback_count : "-"} &nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                      d="M2.08327 13.2333C1.72771 13.2333 1.41938 13.1028 1.15827 12.8417C0.897157 12.5806 0.766602 12.2722 0.766602 11.9167V2.08333C0.766602 1.71667 0.897157 1.40278 1.15827 1.14167C1.41938 0.880556 1.72771 0.75 2.08327 0.75H6.64994V2.08333H2.08327V11.9167H11.9166V7.35H13.2499V11.9167C13.2499 12.2722 13.1194 12.5806 12.8583 12.8417C12.5972 13.1028 12.2833 13.2333 11.9166 13.2333H2.08327ZM5.58327 9.35L4.6666 8.41667L10.9999 2.08333H7.64994V0.75H13.2499V6.35H11.9166V3.01667L5.58327 9.35Z"
                      fill="#957137"
                    />
                  </svg>
                </button>
              </Link>
            ) : (
              <button onClick={(e) => e.preventDefault()} className="Count_btn">
                {" "}
                {item.feedback_count ? item.feedback_count : "-"} &nbsp;
              </button>
            )}
          </li>
        </ul>
      </th>
      <th scope="row">
        <ul>
          <p>
            <div>
              <div style={{ fontSize: 14, width: "370px", fontWeight: "420", color: "#2E294E" }}>
                {item.comment_list &&
                  JSON.parse(item.comment_list).map((comment, index) => <li key={index}>{comment ? comment : "-"}</li>)}
              </div>
            </div>
          </p>
        </ul>
      </th>
    </tr>
  );
}

export default function Feedback() {
  const user_Role = localStorage.getItem("access_Role");
  var token = localStorage.getItem("access_token");
  const today = new Date();
  today.setHours(0,0,0,0)
  const prevWeekStart = new Date(today);
  prevWeekStart.setDate(today.getDate() - 14 - today.getDay());
  const currentEndDate = new Date(today);

  const dispatch = useDispatch()
  const [star, setStar] = useState('')
  const [value, setValue] = useState([])
  // Same date range as value but never narrowed by the Rating filter - the
  // day-rating chart takes its bar heights from here so filtering only
  // picks which days show, not what each day's bar reads.
  const [unfilteredValue, setUnfilteredValue] = useState([])
  const [catererdata, setCatererdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [caterer, setCaterer] = useState('')
  const [startDate, setStartDate] = useState(prevWeekStart)
  const [endDate, setEndDate] = useState(currentEndDate);

  const [selectecStartDate, setSelectedStartDate] = useState('')
  const [selectecEndDate, setSelectedEndDate] = useState('');
  const [rating, setRating] = useState('');
  // Opened in place of navigating to /ScheduleFeedback, so the filters
  // above (startDate/endDate/rating/caterer) never reset - there's no
  // navigate-away-and-back for them to be lost across.
  const [scheduleFeedbackModal, setScheduleFeedbackModal] = useState(null); // { item, feedbacks } | null

  const csvData = value.map((items) => {
    const overallRating = getOverallRating(items);
    return {
        Date: items.schedule_day,
        Menu: JSON.parse(items.menu),
        Type: items.schedule_type,
        CatererName: items.cater_name1,
        Rating: overallRating != null ? overallRating.toFixed(1) : "",
        Notes: JSON.parse(items.comment_list)
    };
});

const csvHeaders = [
    { label: "Date", key: "Date" },
    { label: "Menu", key: "Menu" },
    { label: "Type", key: "Type"},
    { label: "Caterer Name", key: "CatererName" },
    { label: "Rating", key: "Rating" },
    { label: "Notes", key: "Notes" },
];

  // One bar per day that actually has feedback in the currently loaded
  // range (value) - averaging each schedule's overall rating (see
  // getOverallRating) across every schedule that fell on that day, so a day
  // with both an FMB and a Miqaat schedule still gets just one bar. The
  // lowest-rated day is colored differently so it stands out at a glance.
  // When the Rating filter is applied, value only decides which days get a
  // bar; the height is still that day's full average from unfilteredValue.
  const dayRatingChartData = useMemo(() => {
    const ratingsByDay = new Map();
    (unfilteredValue || []).forEach((item) => {
      if (!item.schedule_day) return;
      const rating = getOverallRating(item);
      if (rating == null) return;
      const key = getDayKey(item);
      if (!ratingsByDay.has(key)) ratingsByDay.set(key, []);
      ratingsByDay.get(key).push(rating);
    });
    const byDay = new Map();
    (value || []).forEach((item) => {
      if (!item.schedule_day) return;
      const key = getDayKey(item);
      if (!byDay.has(key)) {
        byDay.set(key, { key, date: convertDateForIos(item.schedule_day), items: [], ratings: [] });
      }
      const entry = byDay.get(key);
      entry.items.push(item);
      const rating = getOverallRating(item);
      if (rating != null) entry.ratings.push(rating);
    });
    const days = Array.from(byDay.values())
      .map((d) => {
        const ratings = ratingsByDay.get(d.key) || d.ratings;
        return {
          ...d,
          avgRating:
            ratings.length > 0
              ? Math.round((ratings.reduce((sum, r) => sum + r, 0) / ratings.length) * 100) / 100
              : 0,
        };
      })
      .sort((a, b) => a.date - b.date);
    const categories = days.map(
      (d) => `${d.date.toLocaleString("en-US", { weekday: "short" })} ${d.date.getMonth() + 1}/${d.date.getDate()}`
    );
    const data = days.map((d) => d.avgRating);
    const ratedValues = data.filter((v) => v > 0);
    const minVal = ratedValues.length > 0 ? Math.min(...ratedValues) : null;
    // Miqaat days get the same blue used for the Miqaat badge/tag everywhere
    // else in the app (.mp-miqaat-tag, Draft_MIQAAT_event) so the bar reads
    // as "Miqaat" at a glance; the worst-rated day still wins out in red.
    const colors = days.map((d, i) => {
      if (minVal !== null && data[i] === minVal) return "#C62828";
      const isMiqaat = d.items.some((item) => item.schedule_type === "MIQAAT");
      return isMiqaat ? "#5C5EC1" : "#957137";
    });
    return { days, categories, data, colors };
  }, [value, unfilteredValue]);

  // Clicking a bar opens the exact same feedback modal as clicking that
  // schedule's row in the main list (getFeedbackforSchedule, defined
  // below) - if a day happens to have more than one schedule (e.g. FMB and
  // Miqaat the same day), the first one is used, same as the list only
  // ever having one feedback-count button per row to begin with.
  const handleDayBarClick = (event, chartContext, config) => {
    const day = dayRatingChartData.days[config.dataPointIndex];
    if (day?.items?.[0]) getFeedbackforSchedule(day.items[0]);
  };

  const Starlist = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
  ];
  const getCatererData = () => {
    setLoading(true);
    dispatch(getFeedbackdata())
      .then((res) => {
        setValue(res?.payload?.data);
        setUnfilteredValue(res?.payload?.data);
      })
      .catch((error) => {
        // Handle errors if the fetch operation fails.
        // You can display an error message or handle it as needed.
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false when data fetching is complete
      });
  };

  const getCatererDataList = () => {
    dispatch(getCatererList()).then((res) => {
      if (res?.payload?.status == true) {
        setCatererdata(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };
  console.log(catererdata, 'catererdata')
  useEffect(() => {
    getCatererData();
    getCatererDataList();
  }, [])
  console.log(value, 'value')

  let Catererlist;
  if (value && Array.isArray(value)) {
    Catererlist = value.map((item) => ({
      label: item.first_name,
      value: item._id,
    }));
  } else {
    Catererlist = [];
  }

  let Caterer;
  if (catererdata && Array.isArray(catererdata)) {
    Caterer = catererdata?.map((item) => ({
      label: item.first_name,
      value: item._id,
    }));
  } else {
    Caterer = [];
  }
  console.log(value, caterer, 'dfdfdfs');

  const handleDateChange = (event) => {
    const selectedDates = event.target.value.split(" - ");
    const selectedStartDate = selectedDates[0];
    const selectedEndDate = selectedDates[1];
    setStartDate(selectedStartDate);
    setEndDate(selectedEndDate);

    setSelectedStartDate(selectedStartDate);
    setSelectedEndDate(selectedEndDate);

    const partsStart = selectedStartDate.split("/");
    const formattedStartDate = `${partsStart[2]}-${partsStart[0].padStart(2, '0')}-${partsStart[1].padStart(2, '0')}`;

    const partsEnd = selectedEndDate.split("/");
    const formattedEndDate = `${partsEnd[2]}-${partsEnd[0].padStart(2, '0')}-${partsEnd[1].padStart(2, '0')}`;

    console.log("Selected Dates:", "startDate =", formattedStartDate, "endDate =", formattedEndDate);

    // Call getdatechange with the formatted start and end dates and the rating
    getdatechange(formattedStartDate, formattedEndDate, rating);
  };


  // Function to make the API request with parameters in the URL
  const getdatechange = (formattedStartDate, formattedEndDate, rating) => {



    // Construct the URL with query parameters
    const url = feed_back + `admin/feedback-get?start_date=${formattedStartDate}&end_date=${formattedEndDate}&dish_rating=${rating}`;

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json", // Assuming you're sending form data
        Authorization: localStorage.getItem("access_token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data?.status === true) {
          console.log('new data ', data.data);
          // Display a success message using toast
          toast.success(data?.message);
          setValue(data.data)
          if (!rating) setUnfilteredValue(data.data)
          // Set your data in state or perform other actions here
        } else {
          // Display an error message using toast
          toast.error(data?.message);
        }
      })
      .catch(error => {
        console.error(error);
        // Display a generic error message using toast
        toast.error('An error occurred while fetching data.');
      });
  };

  const Ratingselect = (selectedOption) => {
    setStar(selectedOption)

    getdatechange2(selectedOption)

  }


  const getdatechange2 = (selectedOption) => {
    const starLabel = selectedOption?.label ?? "";
    let url = ''
    if(selectecStartDate) {
        const partsStart = selectecStartDate.split("/");
        const formattedStartDate = `${partsStart[2]}-${partsStart[0].padStart(2, '0')}-${partsStart[1].padStart(2, '0')}`;
        const partsEnd = selectecEndDate.split("/");
        const formattedEndDate = `${partsEnd[2]}-${partsEnd[0].padStart(2, '0')}-${partsEnd[1].padStart(2, '0')}`;
        url = feed_back + `admin/feedback-get?start_date=${formattedStartDate}&end_date=${formattedEndDate}&dish_rating=${starLabel}`;
    } else {
        const today = new Date();
        today.setHours(0,0,0,0)
        const prevWeekStart = new Date(today);
        prevWeekStart.setDate(today.getDate() - 14 - today.getDay());

        const start_date = prevWeekStart.toISOString().split("T")[0]
        const currentEndDate = new Date(today);
        const end_date = currentEndDate.toISOString().split("T")[0]
         url =  feed_back + `admin/feedback-get?start_date=${start_date}&end_date=${end_date}&dish_rating=${starLabel}`;
    }
    // Construct the URL with query parameters
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",// Assuming you're sending form data
        Authorization: localStorage.getItem("access_token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data?.status === true) {
          console.log('new data ', data.data);
          // Display a success message using toast
          toast.success(data?.message);
          setValue(data.data)
          if (!starLabel) setUnfilteredValue(data.data)
          // Set your data in state or perform other actions here
        } else {
          // Display an error message using toast
          toast.error(data?.message);
        }
      })
      .catch(error => {
        console.error(error);
        // Display a generic error message using toast
        toast.error('An error occurred while fetching data.');
      });
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return ""; // return empty string if dateString is undefined or empty
    }

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });

    if (isNaN(day)) {
      return ""; // return empty string if parsing fails
    }

    return `${day} ${month}`;
  };


  const feedback = value !== null && value !== undefined ? value.length : null;

  console.log('feedback', feedback)

  const getFeedbackforSchedule = async (item) => {
    setLoading(true);

    const requestBody = {
      schedule_id: item.schedule_id,
    };

    fetch(feed_back + `admin/getFeedbackByScheduleId?${user_Role.includes("FBM") && 'includeNames=true'}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === true) {
          console.log("new data ", data.data);
          const feedbacks = data?.data;
          setScheduleFeedbackModal({ item, feedbacks });
        } else {
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false when data fetching is complete
      });
  }

  return (
    <>
      <Header />
      <div
        className="side_div_menu"
        style={{ display: "flex", height: "100%" }}
      >
        <Sidebarmenu />
        <section className="main_section">
          <div className="custam">
            <div className="main_section2">
              <div className="thali_section">
                <div className="thili_div thali-flex container-fluid">
                  <div className="Back-page">
                    {" "}
                    <h1 className="title_heading">
                      Feedback ({feedback ? feedback : '-'}) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      {/* <span className="Line_div">|</span> */}
                      {/* <span className="Date_list">
                        {formatDate(startDate)}-{formatDate(endDate)}</span>{" "} */}
                    </h1>{" "}
                  </div>
                  <div className="Feedback_list">
                    <div className="Form_box rating_star">
                      <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: "#2E294E", marginBottom: 4 }}>
                        Rating
                      </label>
                      <Select
                        placeholder="Rating"
                        onChange={Ratingselect}
                        options={Starlist}
                        // defaultV alue={cleartype}
                        value={star}
                        isClearable
                      />
                      {/* <select id="Portion" className="form-select">
                        <option selected>State...</option>
                        <option>...</option>
                      </select> */}
                    </div>
                    {/* <span>|</span> */}
                    {/* <div className="Form_box rating_star">
                      <Select
                        placeholder="Caterers"
                        onChange={(e) => setCaterer(e.label)}
                        options={Caterer}

                        value={Caterer.value}

                      />
                    </div> */}
                    <span>|</span>
                    <div className="PickerSelect_list">
                      <div className='Picker_div'>
                        <img src={calender} className='img-fluid' /> &nbsp; &nbsp;
                        <DateRangePicker
                          initialSettings={{ startDate: startDate, endDate: endDate }}
                          // onDateChange={handleDateChange}
                          onApply={handleDateChange}
                        >
                          <input
                            type="text"
                            className="Picker_inside_div"
                            defaultValue={startDate}
                          />
                        </DateRangePicker>
                      </div>
                      <span className="Line_div">|</span>
                      <button className="btn thali_btn csvbtn">
                          <CSVLink data={csvData} headers={csvHeaders} filename={"Feedback_List.csv"}>
                              Export
                          </CSVLink>                
                      </button>
                    </div>
                  </div>
                </div>

                {dayRatingChartData.categories.length > 0 && (
                  <div className="inventory-week-chart-card">
                    <div className="inventory-week-chart-header">
                      <span>Rating by Day</span>
                      <div style={{ display: "flex", alignItems: "center", gap: 14, fontWeight: 500, fontSize: 12 }}>
                        {[
                          { label: "FMB", color: "#957137" },
                          { label: "Miqaat", color: "#5C5EC1" },
                          { label: "Lowest Rated", color: "#C62828" },
                        ].map(({ label, color }) => (
                          <span key={label} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                            <span
                              style={{
                                width: 9,
                                height: 9,
                                borderRadius: "50%",
                                backgroundColor: color,
                                display: "inline-block",
                              }}
                            />
                            {label}
                          </span>
                        ))}
                      </div>
                    </div>
                    <ReactApexChart
                      type="bar"
                      height={260}
                      series={[{ name: "Rating", data: dayRatingChartData.data }]}
                      options={{
                        chart: {
                          toolbar: { show: false },
                          events: { dataPointSelection: handleDayBarClick },
                        },
                        plotOptions: {
                          bar: {
                            columnWidth: "45%",
                            borderRadius: 4,
                            distributed: true,
                            dataLabels: { position: "top" },
                          },
                        },
                        dataLabels: {
                          enabled: true,
                          offsetY: -18,
                          formatter: (val) => (val > 0 ? val.toFixed(1) : "-"),
                          style: { fontSize: "11px", colors: ["#2E294E"] },
                        },
                        legend: { show: false },
                        colors: dayRatingChartData.colors,
                        xaxis: {
                          categories: dayRatingChartData.categories,
                          labels: { style: { fontSize: "11px" } },
                        },
                        yaxis: { max: 5, labels: { style: { fontSize: "11px" } } },
                        grid: { borderColor: "#F0F0F0" },
                        tooltip: { y: { formatter: (val) => (val > 0 ? val.toFixed(1) : "No ratings") } },
                      }}
                    />
                  </div>
                )}

                <div className="thali_table_section ">
                {loading ? (
                    // Render a loading indicator while data is being fetched
                    <div className='Loading-img'><img src={loadergif} className='' /></div>

                  ) : (
                    <div></div>
                  )
                  }
                  <table className="table table-bordered">
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col">
                          <span className="thali_table">Day & Date</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Menu</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Caterers</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Rating</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Notes</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {value &&
                        value.map((item) => (
                          <FeedbackRow key={item.id} item={item} userRole={user_Role} onOpenFeedback={getFeedbackforSchedule} />
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal
        isOpen={Boolean(scheduleFeedbackModal)}
        onRequestClose={() => setScheduleFeedbackModal(null)}
        style={customStyles}
        contentLabel="Schedule Feedback"
        id="schedule_feedback_modal"
      >
        <div className="popup_modal">
          <div className="d-flex justify-content-between align-items-center">
            <div className="Popup_heding">
              <h1>Feedback</h1>
            </div>
            <button onClick={() => setScheduleFeedbackModal(null)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M6.99967 8.19364L1.82142 13.3719C1.65149 13.5418 1.45257 13.6268 1.22467 13.6268C0.996772 13.6268 0.797855 13.5418 0.627922 13.3719C0.458005 13.202 0.373047 13.0031 0.373047 12.7752C0.373047 12.5473 0.458005 12.3483 0.627922 12.1784L5.8062 7.00016L0.627922 1.82191C0.458005 1.65198 0.373047 1.45306 0.373047 1.22516C0.373047 0.99726 0.458005 0.798344 0.627922 0.62841C0.797855 0.458494 0.996772 0.373535 1.22467 0.373535C1.45257 0.373535 1.65149 0.458494 1.82142 0.62841L6.99967 5.80668L12.1779 0.62841C12.3479 0.458494 12.5468 0.373535 12.7747 0.373535C13.0026 0.373535 13.2015 0.458494 13.3714 0.62841C13.5413 0.798344 13.6263 0.99726 13.6263 1.22516C13.6263 1.45306 13.5413 1.65198 13.3714 1.82191L8.19315 7.00016L13.3714 12.1784C13.5413 12.3483 13.6263 12.5473 13.6263 12.7752C13.6263 13.0031 13.5413 13.202 13.3714 13.3719C13.2015 13.5418 13.0026 13.6268 12.7747 13.6268C12.5468 13.6268 12.3479 13.5418 12.1779 13.3719L6.99967 8.19364Z"
                  fill="#2E294E"
                />
              </svg>
            </button>
          </div>
        </div>
        {scheduleFeedbackModal && (
          <ScheduleFeedbackContent
            item={scheduleFeedbackModal.item}
            feedbacks={scheduleFeedbackModal.feedbacks}
          />
        )}
      </Modal>
    </>
  );
}
